import React, {Component} from "react";
import {observer} from 'mobx-react';
import {Card, Typography, Icon, Button} from 'antd';
import {appStore} from '../../stores/AppStore';
// import '../aboutus.css';
import AgGrid from '../AgGrid';
import store from '../../stores/DashboardStore';


class SummaryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
             summaryData:[],
             summaryColumns : [
                {headerName: "Row", valueGetter: "node.rowIndex + 1"},
                {headerName: 'Total Monograph', field: 'totalMonograph'},
                {headerName: 'Awaiting Acquisition', field: 'awaitingAcquisition'},
                {headerName: 'Planned Acquisition', field: 'plannedAcquisition'},
                {headerName: 'In Acquisition', field: 'inAcquisition'},
                {headerName: 'Do Not Chase', field: 'doNotChase'}
             ]
        }
    }
    componentDidMount= async()=> {
        const rowdata = await this.getSummaryData();
        this.setState({summaryData:rowdata})
    }
    getSummaryData = async()=>{
        this.activeFilter = 'SummaryTable';
         let totalMonograph =[];
         let flags = [];
         let summaryRows=[];
        for(let i=0; i<store.currentTable.length; i++) {
            if(flags[store.currentTable[i].abbreviation]) continue;
            flags[store.currentTable[i].abbreviation] = true;
            totalMonograph.push(store.currentTable[i].abbreviation);
        }
       
        for(let i=0; i<totalMonograph.length; i++)
        {
           let total = store.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i])});
           let awaitingAcquisition = store.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Awaiting Acquisition")});
           let plannedAcquisition = store.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Planned Acquisition")});
           let inAcquisition = store.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "In Acquisition")});
           let doNotChase = store.currentTable.filter(function(element) { return (element.abbreviation == totalMonograph[i] && element.stage == "Do Not Chase")});
           summaryRows.push({
                totalMonograph:total.length,
                awaitingAcquisition:awaitingAcquisition.length,
                plannedAcquisition:plannedAcquisition.length,
                inAcquisition:inAcquisition.length,
                doNotChase:doNotChase.length
           })
        }
        console.log(summaryRows);
        return summaryRows;
      

     }
     handleCellClicked = (params) => {
     }
    render() {
        const {summaryData, summaryColumns} = this.state;
        return (
            <div>
                
                 <AgGrid
                    rowData={summaryData}
                    columnDefs={summaryColumns}
                    onCellClicked={this.handleCellClicked}
                    onGridReady={this.onGridReady}  
                />
                </div>  
          
        )
    }

  
}

export default SummaryTable;
